namespace TabAurous.Reports {
    export interface PriceBifurcationRow {
        TransId?: number;
        TransItemId?: number;
        ProductId?: number;
        AttributeId?: number;
        Status?: string;
        Image?: string;
        ImageLength?: number;
        ProductCode?: string;
        ProductName?: string;
        StampCode?: string;
        ProductSizeCode?: string;
        SuperTypeCode?: string;
        RefNo?: string;
        Pieces?: number;
        CompanyCode?: string;
        DeptName?: string;
        MetalColorName?: string;
        ProductLink?: string;
        Purity?: number;
        PureWeight?: number;
        MetalGrossWeight?: number;
        MetalNetWeight?: number;
        MetalNetAmount?: number;
        KaratId?: number;
        MetalName?: string;
        DiamondType?: string;
        DiamondPieces?: number;
        DiamondWeight?: number;
        TotalDiamondWeight?: number;
        DiamondRate?: number;
        DiamondAmount?: number;
        StoneType?: string;
        StonePieces?: number;
        TotalStoneWeight?: number;
        StoneWeight?: number;
        StoneRate?: number;
        StoneAmount?: number;
        UnitLabour?: number;
        TotalLabour?: number;
        Discount?: number;
        GrossAmount?: number;
        Remark?: string;
        MF?: number;
        MFAmount?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
    }

    export namespace PriceBifurcationRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'Reports.PriceBifurcation';
        export const deletePermission = 'Reports:Transaction:Price BifurcationRow';
        export const insertPermission = 'Reports:Transaction:Price BifurcationRow';
        export const readPermission = 'Reports:Transaction:Price BifurcationRow';
        export const updatePermission = 'Reports:Transaction:Price BifurcationRow';

        export declare const enum Fields {
            TransId = "TransId",
            TransItemId = "TransItemId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Status = "Status",
            Image = "Image",
            ImageLength = "ImageLength",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            StampCode = "StampCode",
            ProductSizeCode = "ProductSizeCode",
            SuperTypeCode = "SuperTypeCode",
            RefNo = "RefNo",
            Pieces = "Pieces",
            CompanyCode = "CompanyCode",
            DeptName = "DeptName",
            MetalColorName = "MetalColorName",
            ProductLink = "ProductLink",
            Purity = "Purity",
            PureWeight = "PureWeight",
            MetalGrossWeight = "MetalGrossWeight",
            MetalNetWeight = "MetalNetWeight",
            MetalNetAmount = "MetalNetAmount",
            KaratId = "KaratId",
            MetalName = "MetalName",
            DiamondType = "DiamondType",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            TotalDiamondWeight = "TotalDiamondWeight",
            DiamondRate = "DiamondRate",
            DiamondAmount = "DiamondAmount",
            StoneType = "StoneType",
            StonePieces = "StonePieces",
            TotalStoneWeight = "TotalStoneWeight",
            StoneWeight = "StoneWeight",
            StoneRate = "StoneRate",
            StoneAmount = "StoneAmount",
            UnitLabour = "UnitLabour",
            TotalLabour = "TotalLabour",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            MF = "MF",
            MFAmount = "MFAmount",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId"
        }
    }
}
